/**
 * When a newer build takes over, which page it may reload under the person.
 *
 * The worker updates itself (vite-plugin-pwa's autoUpdate: skipWaiting and
 * clientsClaim), so after a deploy the new worker takes control of a page
 * that is already open. Nothing then reloaded that page: it kept the old
 * shell it had been served, and the old route chunks it had in the HTTP
 * cache, and a prospect who had opened the demo once went on seeing the
 * September demo with its ten tabs for as long as they kept the tab or the
 * installed app. The README called that expected. It is not: a demo link
 * has to open the demo that was shipped.
 *
 * So when a new worker takes control of a page that an older one was
 * serving, the page reloads: at once where nothing can be lost, and on the
 * next navigation elsewhere, so nobody loses a form they are halfway
 * through. Pure, so the rule is tested without a browser.
 */

/**
 * Pages that hold nothing a reload could lose: a reload may happen at
 * once. The demo and the root only. The sign-in and sign-up pages were
 * here too, and a new worker claims a page a few seconds after it opens,
 * which on those pages is while someone is typing an email address and a
 * password: the reload blanked the form. They wait for the next
 * navigation, which after a sign-in is the move into the workspace.
 */
const STATELESS = /^\/(demo)?(\/|$)/;

export function mayReloadNow(pathname: string): boolean {
  return STATELESS.test(pathname);
}

/**
 * Whether a controller change is an update to react to. The first install
 * also fires it (clientsClaim takes the page), and reloading a first visit
 * would reload every first visit; only a page that already had a worker is
 * on an older build.
 */
export function isUpdate(hadController: boolean): boolean {
  return hadController;
}
